import React, { FC } from 'react'
import { Edit, EditProps, SimpleForm } from 'react-admin'
import { makeStyles } from '@material-ui/core'

import { FormProvider } from 'contexts/FormProvider'

import { Drawers, EditForm, CreateCourseToolbar } from '../containers'

const useStyles = makeStyles({
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
})

export const EditLesson: FC<EditProps> = (props) => {
  const classes = useStyles()

  return (
    <>
      <Drawers {...props} />

      <Edit {...props}>
        <SimpleForm warnWhenUnsavedChanges className={classes.formContainer}>
          <FormProvider>
            <EditForm toolbar={<CreateCourseToolbar />} />
          </FormProvider>
        </SimpleForm>
      </Edit>
    </>
  )
}
